import React from 'react';
import { Modal } from 'react-bootstrap';

import OrderListContainer from '../containers/OrderListContainer.jsx';
import OrderFlowEditContainer from '../containers/OrderFlowEditContainer.jsx';
import OrderEditContainer from '../containers/OrderEditContainer.jsx';
import OrderDetailEditContainer from '../containers/OrderDetailEditContainer.jsx';
import OrderViewContainer from '../containers/OrderViewContainer.jsx';

const OrdersComponent = ({
  // state
  showAddOrderModal,
  showEditOrderModal,
  showEditOrderDetailModal,
  showViewOrderModal,
  // dispatch
  closeModal
}) => (

    <div>
      <h4>訂單管理</h4>
      <OrderListContainer />
      <Modal bsSize="large" show={showAddOrderModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton />
        <Modal.Body>
          <OrderFlowEditContainer />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={showEditOrderModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton />
        <Modal.Body>
          <OrderEditContainer />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={showEditOrderDetailModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton />
        <Modal.Body>
          <OrderDetailEditContainer />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={showViewOrderModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton />
        <Modal.Body>
          <OrderViewContainer />
        </Modal.Body>
      </Modal>
    </div>

  );

export default OrdersComponent;


// WEBPACK FOOTER //
// ./src/components/OrdersComponent.jsx